import React from 'react';
import { ArrowRight, TrendingUp, Shield, Smartphone } from 'lucide-react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              India FNO Trading
              <span className="gradient-text"> & Options Buying</span>
            </h1>
            <p className="hero-subtitle">
              Master Indian stock exchange Futures & Options trading with proven strategies for capital growth.
            </p>
            <div className="hero-actions">
              <a href="#strategies" className="btn btn-primary hero-cta">
                Access Platform
                <ArrowRight className="btn-icon" />
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="strategy-preview">
                <h3>India FNO Focus</h3>
                <div className="strategy-list">
                  <div className="strategy-item">
                    <div className="strategy-icon">📈</div>
                    <div className="strategy-content">
                      <h4>NSE & BSE Options</h4>
                      <p>Master Indian stock exchange options trading</p>
                    </div>
                  </div>
                  <div className="strategy-item">
                    <div className="strategy-icon">🎯</div>
                    <div className="strategy-content">
                      <h4>FNO Strategies</h4>
                      <p>Proven Futures & Options strategies</p>
                    </div>
                  </div>
                  <div className="strategy-item">
                    <div className="strategy-icon">💡</div>
                    <div className="strategy-content">
                      <h4>Capital Growth</h4>
                      <p>Focused on options buying for growth</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
